import {hasher} from 'hasher';
import * as ko from "knockout";
import {IFormTemplate, IMessageData, IObjectData} from "../../../../../index";
import {IDialogOptionsComponent} from "../../../../dialog/index";
import {IPickerOptions} from "../../../../picker/AbstractPicker";
import {ButtonManager} from "../../../../../util/ButtonManager";
import {getCancelButton, getContinueButton} from "../../../../../constants/RouteDefinitions";
import {nsRoute} from "../../../../../util/route";
import PromiseRequest from "../../../../../req/PromiseRequest";
import {PLEASE_WAIT_MESSAGE} from "../../../../../constants/Language";
import {global} from "../../../../../appContext";
import {createErrorMessage} from "../../../../../util/misc";
import {EHubManagerOptions} from "../../../../../../ehub/EHubManager";
import {nsFa} from "../../../../fa/fn";
import {nsFormTemplate} from "../../nsFormTemplate";
import ButtonOrder = nsRoute.ButtonOrder;
import i = nsFa.i;
import openV2form = nsFormTemplate.openV2form;
import openv2Html from './openv2.html?raw';

export let template = openv2Html;

interface IParams {
    form: IFormTemplate
    obj?: IObjectData
    dialog: IDialogOptionsComponent
}

export class viewModel {
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private readonly isReady: KnockoutObservable<boolean> = ko.observable(true);
    private readonly toggleContext: KnockoutObservable<'me' | 'other'> = ko.observable<'me' | 'other'>('me');
    private readonly pickedUser: KnockoutObservable<IObjectData | null> = ko.observable(null)
    private readonly pageButtons: ButtonManager = new ButtonManager()
    private readonly req_emulatelogin: PromiseRequest = new PromiseRequest('emulatelogin')

    constructor(private params: IParams) {
        const cancelButton = getCancelButton(() => {
            this.params.dialog.doClose?.()
        }, {
            validator: () => this.isReady(),
        })
        if (cancelButton) {
            this.pageButtons.add(cancelButton)
        }

        this.pageButtons.add(getContinueButton({
            label: 'open subject|s:((form|ac))',
            onClick: this.onSubmit.bind(this),
            order: ButtonOrder.SUBMIT,
            enabled: () => {
                switch (this.toggleContext()) {
                    case 'me':
                        return true
                    case 'other':
                        return !!this.pickedUser()
                }
            },
            validator: () => this.isReady(),
        }))
    }

    getPickerUserOptions(): IPickerOptions<IObjectData> {
        return {
            observable: this.pickedUser,
            label: 'choose subject|s:((user|ac))',
            placeholder: 'choose subject|s:((user|ac))',
        }
    }

    onSubmit() {
        if (this.toggleContext() == 'me') {
            let options: any = {
                mode: 'submit',
            };
            if (this.params.obj?.id) {
                options.targetid = this.params.obj.id
            }
            openV2form(this.params.form, options)
            this.params.dialog.doClose?.()
            return
        }

        let emulatedToken: string
        const logoutEmulatedToken = () => {
            if (emulatedToken) {
                new PromiseRequest('logout')
                    .request({token: emulatedToken})
                    .catch(/* die silently*/)
            }
        }

        const currentHash = hasher.getHash()
        global.router.onHashChange = () => Promise.resolve(currentHash)

        this.params.dialog.isClosable?.(false)
        const options: Partial<EHubManagerOptions> = {
            form: this.params.form.id,
            mode: 'submit',
            ...(this.params.obj?.id != null ? {targetId: this.params.obj.id} : {}),
        }
        const events: Partial<IEHubManagerEvents> = {
            cancel: () => {
                delete global.router.onHashChange;
                logoutEmulatedToken()
                global.snackbarData({message: `${i('fa-ban')} ((cancelled)) ((formdata|ac))`})
            },
            submit: () => {
                delete global.router.onHashChange;
                logoutEmulatedToken()
                global.snackbarData({message: `${i('fa-check')} ((submitted)) ((formdata|ac))`})
            },
        }

        this.isReady(false)
        this.messageData({message: PLEASE_WAIT_MESSAGE})
        const pickedUser = this.pickedUser();
        if (!pickedUser) {
            return;
        }
        const userid = pickedUser.id;
        this.req_emulatelogin
            .request({userid: userid})
            .then((data: [string]) => {
                emulatedToken = options.token = data[0]
                options.emulatedLoginId = userid
                global.eHubManager.start(options, events)
                this.params.dialog.doClose?.()
            })
            .catch((reason: string) => {
                global.snackbarData(createErrorMessage(String(reason)))
                this.params.dialog.doClose?.()
            })
    }

    dispose() {
        this.req_emulatelogin.abort()
    }
}
